<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add Gift
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                label="Name"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.price"
                outlined
                label="Price"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                v-model="form.gift_type_id"
                :items="giftTypeItems"
                outlined
                label="Gift Type"
                prepend-inner-icon="mdi-format-list-numbered"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                v-model="form.vip_level_id"
                :items="vipLevelOptions"
                item-text="level"
                item-value="id"
                outlined
                label="VIP Gifts"
                prepend-inner-icon="mdi-format-list-numbered"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                v-model="form.event_type"
                :items="envtTypeItems"
                outlined
                label="Event Type"
                prepend-inner-icon="mdi-format-list-numbered"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <input
                type="file"
                id="file"
                name="file"
                :ref="`file`"
                @change="onFileChange"
              />
              <v-btn
                x-small
                class="reset_image my-1"
                color="red"
                dark
                @click="($refs.file.value = null), (image_path = null)"
                >Remove</v-btn
              >

              <div id="preview" v-if="image_path" class="mt-5">
                <label for="">Image Preview</label>
                <br />
                <img
                  :src="image_path"
                  style="height: 30%; width: 30% !important"
                />
              </div>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Gift
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "GiftCreatePage",
  data() {
    return {
      form: {
        name: "",
      },
      isLoading: false,
      image_path: "",
      vipItems: [],
      giftTypeItems: [],
      envtTypeItems: [{ id: 1, text: "Weekly Star", value: "Weekly Star" }],
    };
  },
  computed: {
    vipLevelOptions() {
      return this.vipItems.map((item) => ({
        ...item,
        level: `VIP ${item.level}`,
      }));
    },
  },
  mounted() {
    this.getVipLevels();
  },
  methods: {
    async getVipLevels() {
      try {
        const response = await axios.get("/masters?context=vipLevels");
        this.vipItems = response.data.vipLevels;
        this.masters = response.data;
        console.log("this.vipItems", this.masters);
        this.masters.gift_types.forEach((giftType) => {
          this.giftTypeItems.push({
            id: giftType.id,
            text: giftType.description,
            value: giftType.id,
          });
        });
        console.log("this.vipItems", this.vipItems);
      } catch (e) {
        console.log(e);
      }
    },
    async save() {
      try {
        this.isLoading = true;
        let gifts = await axios.post("/gifts", this.form);
        this.gifts = gifts.data.data;
        console.log("gifts", this.gifts);
        await this.handleFileUpload();
        await this.saveUserTimestamp(null, this.form);
        this.isLoading = false;
        this.$router.back();
      } catch (e) {
        // alert("error");
        console.log(e);
        this.isLoading = false;
      }
    },
    async handleFileUpload() {
      if (this.$refs.file != null) {
        let attachment = this.$refs.file.files[0];
        let formData = new FormData();
        formData.append("id", this.gifts.id);
        formData.append("image_path", attachment);
        await axios
          .post("upload_gifts_image", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .catch(function (error) {
            console.log(error);
            console.log("FAILURE!!");
          });
      }
    },
    onFileChange() {
      this.warningImageLoader = false;
      this.file = this.$refs.file?.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(this.file);
      reader.onload = (evt) => {
        let img = new Image();
        img.onload = () => {
          this.imageLoader = false;
          this.image_path = URL.createObjectURL(this.file);
          this.imageErrors = "";
        };
        img.src = evt.target.result;
      };

      reader.onerror = (evt) => {
        console.error(evt);
      };
      // this.image_path = URL.createObjectURL(this.file);
    },
  },
};
</script>
